import React from "react";
import { Link } from "react-router-dom";
import ArrowIcon from "./svg/ArrowIcon";

type NavigationItem = {
  id: string | number;
  img: string;
  title: string;
  imgAlt?: string;
};

type NavigationLinksProps = {
  prevItem: any;
  nextItem: any;
  basePath: string;
};

const NavigationLinks: React.FC<NavigationLinksProps> = ({
  prevItem,
  nextItem,
  basePath,
}) => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="details-navigation">
          <div className="single-navigation">
            {prevItem && (
              <>
                <Link to={`/${basePath}/${prevItem.id}`} className="img">
                  <img src={prevItem.bannerImage} alt="" />
                  <div className="arrow">
                    <ArrowIcon />
                  </div>
                </Link>
                <div className="content">
                  <Link to={`/${basePath}/${prevItem.id}`}>Previous</Link>
                  <h4>
                    <Link to={`/${basePath}/${prevItem.id}`}>
                      {prevItem.title.length > 40
                        ? prevItem.title.slice(0, 40) + "..."
                        : prevItem.title}
                    </Link>
                  </h4>
                </div>
              </>
            )}
          </div>
          <div className="single-navigation two">
            {nextItem && (
              <>
                <div className="content">
                  <Link to={`/${basePath}/${nextItem.id}`}>NEXT </Link>
                  <h4>
                    <Link to={`/${basePath}/${nextItem.id}`}>
                      {nextItem.title.length > 40
                        ? nextItem.title.slice(0, 40) + "..."
                        : nextItem.title}
                    </Link>
                  </h4>
                </div>
                <Link to={`/${basePath}/${nextItem.id}`} className="img">
                  <img src={nextItem.bannerImage} alt="" />
                  <div className="arrow">
                    <ArrowIcon />
                  </div>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationLinks;
